import Lottie from 'lottie-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { getdateFormat } from '../../../../base/utils';
import { initialStateModel, LoginState } from '../../../../models/model';
import groovyWalkAnimation1 from "../../../../styles/images/delivery_1nd_tick.json";
import groovyWalkAnimation2 from "../../../../styles/images/delivery_2nd_tick.json";
import styles from "./chatrightinfo.module.scss";

type userDetails = {
  userDetails: any;
  timeStamp: any;
  message: any;
  isPopup?: boolean;
};

export default function ChatRightInfo({ userDetails, timeStamp, message, isPopup }: userDetails) {
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let isBookmark = message && message?.message?.isSave;
  let hovertimestamp = timeStamp !== undefined ? getdateFormat(timeStamp) : "";

  return (
    <>
      {/* { !isPopup && !message.message.isDelete && (!(isBookmark) || isBookmark['s' + userdetails?.sip_login_id]) === 1 ? ( <div className={styles.addBookData}><span className="icon_ribbonfill"></span>
        <label>Added to your saved items</label></div>) :null} */}
     
      <div className={`${styles.convTime} `} >
      {message?.message?.isEdit  &&   <div className={styles.edited}>(edited)</div> }
        {!isPopup && !message.message.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ? (
          <div className={styles.addBookData}>
            <span className="icon_ribbonfill"></span>
          </div>
        ) : null}
        <span>{hovertimestamp}</span>
        {/* <svg className="animated-check" viewBox="0 0 24 24">
        <path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none"></path> </svg> */}
        {!isPopup && (message?.from !== message?.to) && (
          <>
            {message.deliveryStatus === 8 && message.readStatus === 1 && message.message.isDelete ? (
              ""
            ) : 
           message.deliveryStatus === 8 && message.readStatus === 1 ? (
              <span className="readMsg fadeIn"></span>
            ) : message.deliveryStatus === 8 && message.readStatus === 0 && message.message.isDelete ? (
              ""
            ) : message.deliveryStatus === 8 && message.readStatus === 0 ? (
              <Lottie className="svgsendtick"
              animationData={groovyWalkAnimation2} loop={false}/>
            ) : message.deliveryStatus === 4 && message.message.isDelete ? (
              ""
            ) : message.deliveryStatus === 4 ? (
              <Lottie className="svgsendtick"
        animationData={groovyWalkAnimation1} loop={false}/>
            ) : message.deliveryStatus === 2 && message.message.isDelete ? (
              ""
            ) : message.deliveryStatus === 2 || message.deliveryStatus === 1 ? (
              <span className="iconTimer"></span>
            ) : (
              <Lottie className="svgsendtick"
              animationData={groovyWalkAnimation1} loop={false}/>
            )}
          </>
        )}
      </div>
      {/* <div className={styles.convMemName}><span>{userdetails?.sip_login_id === userDetails?.sip_login_id? "You": userDetails?.caller_id}</span></div> */}
    </>
  );
}
